import { FormField, InputField } from "common";
import React from "react";

const LimitFormField = () => (
    <FormField
        className="w-30"
        name="limit"
        label="Usage Limit"
        tooltip="One-time use codes expire after a single booking."
    >
        <InputField name="limit" />
    </FormField>
);

export default LimitFormField;
